import actionTypes from './actionTypes';

const { SET_MINIMIZED_VIEW, CLOSE_SIDEBAR, OPEN_SIDEBAR } = actionTypes;

export const setMinimizedView = isMinimized => ({
  type: SET_MINIMIZED_VIEW,
  isMinimized,
});

export const closeSideBar = () => ({
  type: CLOSE_SIDEBAR,
});

export const openSideBar = () => ({
  type: OPEN_SIDEBAR,
});



// WEBPACK FOOTER //
// ./application/actions/viewActions.js